import { Icon, type IconSize } from '../../icons';

type P = {
  size: IconSize;
  subtype: string;
};

const TextFileIcon = ({ size, subtype }: P) => {
  switch (subtype) {
    case 'css':
    case 'html':
    case 'javascript':
    case 'x-java-source':
    case 'x-python':
      return <Icon icon="code-file" size={size} />;
    case 'csv':
    case 'tab-separated-values':
      return <Icon icon="sheet-file" size={size} />;
    case 'plain':
      return <Icon icon="document-file" size={size} />;
    default:
      return <Icon icon="default-file" size={size} />;
  }
};

export default TextFileIcon;
